import createAthletesCardsPdf from './createAthletesCardsPdf';
import DownloadsPicker from '../DownloadsPicker';
import { createAthleteRecord } from '../common';
import FileDownload from '../../../components/FileDownload';

import React from 'react';
import { mapValues } from 'lodash';

const createAthletesCards = (entries, mode) => {
  switch (mode) {
    case 'template':
      return [{}];
    case 'test':
      return [
        {
          teams: ['FIN'],
          name: 'HUBBABUBBA BUBBLE BOSS Something ala Sumthing',
          lotNumber: 999,
          category: '+105 X',
          dateOfBirth: '99.99.9999',
          bodyweight: 199.99,
          entryTotal: '(999)',
        },
      ];
    default:
      return entries.map(createAthleteRecord);
  }
};

const AthletesCardsDownload = ({ entries, mode, ...props }) => {
  const onFileContents = () => {
    return createAthletesCardsPdf(createAthletesCards(entries, mode));
  };
  return (
    <FileDownload
      mimeType="appication/pdf"
      fileName={`athletes-cards-${mode}.pdf`}
      onContents={onFileContents}
      {...props}
    />
  );
};

const AthletesCardsDownloads = ({ entries }) => {
  const modes = mapValues(
    {
      all: 'All cards',
      template: 'Empty template',
      ...(process.env.NODE_ENV !== 'production'
        ? { test: '**Test card**' }
        : {}),
    },
    (text, mode) => ({
      mode,
      text,
      download: <AthletesCardsDownload entries={entries} mode={mode} />,
    }),
  );

  return <DownloadsPicker modes={modes} />;
};

export default AthletesCardsDownloads;



// WEBPACK FOOTER //
// ./src/pages/Home/athletesCards/AthletesCardsDownloads.js